import React from 'react';
import './IntegratedTimeBar.css';

const GlobalRobotEvents = ({ maxTime, events, onEventClick }) => {
  if (!events || !Array.isArray(events)) return null;

  return (
    <div className="global-events-container">
      {events.map((event, index) => {
        if (!event || !event.startTime) return null;
        
        const position = (event.startTime / maxTime) * 100;
        const width = event.duration ? (event.duration / maxTime) * 100 : 2; // Default width for point events
        
        return (
          <div
            key={`global-event-${index}`}
            className="global-event"
            style={{
              left: `${position}%`,
              width: `${width}%`
            }}
            onClick={() => onEventClick(event.startTime, event.robotId, event.id)}
            title={`${event.type} - ${event.description || ''}`}
          />
        );
      })}
    </div>
  );
};

export default GlobalRobotEvents; 